import React, { useEffect, useState } from "react";

import { FaPlus } from "react-icons/fa";
import { HiUsers } from "react-icons/hi2";
import { FaThumbsUp } from "react-icons/fa";
import { MdVisibility } from "react-icons/md";
import { LuRefreshCw } from "react-icons/lu";
import { TiThMenu } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Vikas_Sharma from "../../TeamImages/Sanjay_Jaipuria.jpg";
import { RiGalleryUploadLine } from "react-icons/ri";

interface BusinessStructure {
  id: number;
  giver: number;
  receiver: number;
  workBy: string;
  referenceId: string;
  status: string;
  date: string;
  amount: number;
  Testimonial: string;
  
}

interface ReportStructure {
  InitiatedBy: number;
  approve: string;
  date: string;
  discussion_point: string;
  id: number;
  image: string;
  location: string;
  meetingWith: number;
  type: string;
}

interface ReferenceStructure {
  id: number;
  referenceTo: number;
  referenceBy: number;
  RefPerName: string;
  number: string;
  date: string;
}
interface UserDetails {
  id: number;
  name: string;
  email: string;
  role: string;
  company_name: string;
  profile: string;
  point: number;
  Time: string;
  expire:string;
}

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  desc: string;
  date: string;
  PresentMember:string;
}

interface pointstruc{
  id:number;
  type:string;
  data:number
}
const Userdashbord = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const[pointdata, setPointdata] = useState<pointstruc[]>([]);
  const [usersData, setUsersData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBusinessModalOpen, setIsBusinessModalOpen] = useState(false);
  const [isReferenceModalOpen, setIsReferenceModalOpen] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [userId, setUserID] = useState();

  const [businessData, setBusinessData] = useState<BusinessStructure[]>([]);
  const [reportData, setReportData] = useState<ReportStructure[]>([]);
  const [referenceData, setReferenceData] = useState<ReferenceStructure[]>([]);
  const navigate = useNavigate();
  const [userdetails, setUserdetails] = useState<UserDetails | null>(null);
  const [headingData, setHeadingData] = useState({ title: "" });
  // Fetch data from API

  useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/point`);
            setPointdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
})

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/newsheading`);
        //console.log("Fetched news heading data:", response.data);
        
        if (response.data && response.data.data && response.data.data.length > 0) {

          setHeadingData({ title: response.data.data[0].title });
        }
      } catch (error) {
        console.error("Failed to fetch news heading:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const validateSession = async () => {
      try {
        // Validate the session and retrieve user ID
        const response = await axios.get(`${api}/auth/memberLoggedIn`, {
          withCredentials: true,
        });
        //console.log('Dashboard data:', response.data);
        const uid = response.data.user.id;
        //console.log(`Requesting user details with URL: ${api}/auth/user/${uid}`);

        // Fetch user details
        const userResponse = await axios.get(`${api}/auth/user/${uid}`, {
          withCredentials: true,
        });
        setUserdetails(userResponse.data); // Set user details in state
        setUserID(uid);
      } catch (error: any) {
        console.error(
          "Session validation failed:",
          error.response?.data || error.message
        );
        navigate("/login"); // Redirect to login if session validation fails
      }
    };

    validateSession();
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/reference`);

        // console.log("business data", response.data);
        setReferenceData(response.data.data);
        // console.log("report data in a array", reportData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/memeberpoint`);

        // console.log("member data", response.data);
        setReportData(response.data);
        // console.log("report data in a array", reportData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${api}/auth/business`);

        // console.log("business data", response.data.data);
        setBusinessData(response.data.data);
        // console.log("report data in a array", businessData.length);
      } catch (error) {
        console.error("user Not Found:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchAllUserData = async () => {
      try {
        const response = await axios.get(`${api}/auth/allusersinfo`);

        //console.log("All users data:", response.data);
        setUsersData(response.data); // Set users data
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };

    fetchAllUserData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(
          `${api}/auth/news`
        );

        //console.log('news data',response.data)
        if (!Array.isArray(response.data)) {
          setNewData([response.data]); // Wrap the object in an array
        } else {
          setNewData(response.data); // Set directly if it's an array
        }
        //console.log("news data in a array",newData);
      } catch (error) {
        console.error("Post Not Found:", error);
      }
    };

    fetchData();
  }, []);

  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };
  const openBusinessModal = () => {
    setIsBusinessModalOpen(true);
  };
  const openReferenceModal = () => {
    setIsReferenceModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };
  const closeBusinessModal = () => {
    setIsBusinessModalOpen(false);
  };

  const closeReferenceModal = () => {
    setIsReferenceModalOpen(false);
  };

  const calculateExpiryDate = (time: string): string => {
    const date = new Date(time); // Convert Time to Date
    date.setFullYear(date.getFullYear() + 1); // Add one year
    return date.toISOString().split("T")[0]; // Return in 'YYYY-MM-DD' format
  };



  const totalPresence = newData.reduce((count, items) => {
    const premebArray = items.PresentMember ? JSON.parse(items.PresentMember) : [];
    // console.log('PremebArray:', premebArray); // Debug log for the array
  
    const isPresent = premebArray.some((pid: any) => {
      const match = pid.id === userId && pid.status === 'present';
      // console.log('Checking PID:', pid.id, 'User ID:', userId, 'Match:', match, "pid.status ",pid.status,'news name',items.title);
      return match;
    });
  
    return isPresent ? count + 1 : count;
  }, 0);
  
  // console.log('Total Present for User:', totalPresence);
  
  const totalbusinessamountgiv=()=>{
    let total = 0;
      businessData.filter((items)=>items.giver === userdetails?.id).forEach((item) => {
        total += item.amount;
      });

      return total;
  }

  const totalbusinessamountreceived=()=>{
    let total = 0;
      businessData.filter((items)=>items.receiver === userdetails?.id).forEach((item) => {
        total += item.amount;
      });

      return total;
  }
  

  return (
    <div className="bg-[#1E2A3A] min-h-screen p-[3%]">
      <div className="flex justify-between pb-3 flex-wrap items-start">
        <div className="md:w-[74%] w-[100%] md:order-1 order-2  md:p-[30px]  md:pt-0 pt-3 ">
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
  {/* Total Presence */}
  <div className="bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg  text-white flex flex-col justify-between min-h-[250px] hover:border-textyellow hover:border">
    <div className="text-center">
      <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
        {totalPresence}
      </div>
      <p className="mt-4 text-2xl font-semibold">Total Presence</p>
      <p className="mt-2 text-base">Records showing presence for the user.</p>
    </div>
  </div>

  {/* Business Data Records */}
  {businessData.length > 0 ? (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          {totalbusinessamountgiv().toLocaleString('en-IN')}
        </div>
        <p className="mt-4 text-2xl font-semibold">Business Data Give</p>
        <p className="mt-2 text-base">Records involving the user as giver.</p>
      </div>
    </div>
  ) : (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          0
        </div>
        <p className="text-2xl font-semibold">Business Data Give</p>
        <p className="text-base">No records found.</p>
      </div>
    </div>
  )}
    {businessData.length > 0 ? (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          {totalbusinessamountreceived().toLocaleString('en-IN')}
        </div>
        <p className="mt-4 text-2xl font-semibold">Business Data Receiver</p>
        <p className="mt-2 text-base">Records involving the user as receiver.</p>
      </div>
    </div>
  ) : (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          0
        </div>
        <p className="text-2xl font-semibold">Business Data Receiver</p>
        <p className="text-base">No records found.</p>
      </div>
    </div>
  )}

  {/* Report Data Records */}
  {reportData.length > 0 ? (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          {reportData.filter((items) => (items.InitiatedBy === userId || items.meetingWith === userId) && items.type==='R2R').length}
        </div>
        <p className="mt-4 text-2xl font-semibold">R2R Data Records</p>
        <p className="mt-2 text-base">Records initiated or involving the user.</p>
      </div>
    </div>
  ) : (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          0
        </div>
        <p className=" text-2xl font-semibold">Report Data Records</p>
        <p className="text-base">No records found.</p>
      </div>
    </div>
  )}

  {/* Reference Data Records */}
  {referenceData.length > 0 ? (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          {referenceData.filter((items) => items.referenceTo === userId || items.referenceBy === userId).length}
        </div>
        <p className="mt-4 text-2xl font-semibold">Reference Data Records</p>
        <p className="mt-2 text-base">Records where the user is involved as a reference.</p>
      </div>
    </div>
  ) : (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800  p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          0
        </div>
        <p className="text-2xl font-semibold">Reference Data Records</p>
        <p className="text-base">No records found.</p>
      </div>
    </div>
  )}


   {/* Vistor Data Records */}
   {reportData.length > 0 ? (
    <div className="hover:border-textyellow hover:border bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          {reportData.filter((items) => (items.InitiatedBy === userId || items.meetingWith === userId) && items.type==='Visitor').length}
        </div>
        <p className="mt-4 text-2xl font-semibold">Vistor Data Records</p>
        <p className="mt-2 text-base">Records initiated or involving the user.</p>
      </div>
    </div>
  ) : (
    <div className="bg-gradient-to-r from-darkblue to-gray-800 p-6 rounded-xl shadow-lg text-white flex flex-col justify-between min-h-[250px]">
      <div className="text-center">
        <div className="text-4xl font-bold bg-darkblue text-textyellow rounded-full w-20 h-20 flex items-center justify-center mx-auto">
          0
        </div>
        <p className=" text-2xl font-semibold">Report Data Records</p>
        <p className="text-base">No records found.</p>
      </div>
    </div>
  )}
</div>
     
              <div
                
                className="bg-[#344056] border-[#64748B] px-5 py-2 rounded-[8px] mt-3"
              >
                <h6 className="text-[#F1F4F9] text-[16px] font-medium">
                  Next Meeting / Event
                </h6>
                <h6 className="text-[#F1F4F9] text-[16px] font-medium">
                  Title: {headingData.title || "Untitled"}
                </h6>
                
              </div>
           
        </div>
        <div className="md:w-[25%]  w-[100%] md:order-2 order-1 flex flex-col gap-1 justify-center items-center ">
          <div className="w-[100%]  flex flex-col gap-1 justify-center items-center bg-[#344056]   border-[#64748B] rounded-[8px] p-3">
            <img
              className=" w-[80px] h-[80px] rounded-[50%] mb-2"
              src={`${api}/${userdetails?.profile || "default-profile.png"}`}
              alt=""
            />
            <button className="bg-[#fdbc12] rounded w-[110px] text-darkblue text-[16px] font-medium pt-1 pb-1 mb-2">
              {userdetails?.point}
            </button>
            <h6 className="text-[#F1F4F9] text-[16px] font-medium">
              {userdetails?.name}
            </h6>
            <h6 className="text-[#F1F4F9] text-[12px] font-medium">
              {userdetails?.company_name}
            </h6>
            <h6 className="text-[#F1F4F9] text-[12px] font-medium">
              Joined On : { userdetails?.Time!=null? new Date(userdetails.Time).toLocaleDateString("en-US"):''}
            </h6>
            <h6 className="text-[#F1F4F9] text-[12px] font-medium">
  Expiration :{" "}
  {userdetails?.expire ? (
    <strong>
      {new Date(userdetails.expire).toLocaleDateString("en-US")}
    </strong>
  ) : (
    "N/A"
  )}
</h6>

            <h6 className="text-[#F1F4F9] text-[12px] font-medium">
              Chapter : Jaipur
            </h6>
          </div>
          <div className=" w-[100%] mt-2">
            <div className=" w-[100%] flex justify-between">
              <div
                className="bg-[#02256D]  w-[24%] p-2 flex flex-col justify-center rounded-md cursor-pointer"
                onClick={() => openModal("R2R")}
              >
                <div className="w-[100%] flex justify-end">
                  <FaPlus className="text-[#F1F4F9] text-[12px] cursor-pointer" />
                </div>
                <div className="w-[100%] flex justify-center">
                  <HiUsers className="text-[#F1F4F9] text-[24px]" />
                </div>
                <p className="text-[#F1F4F9] text-[14px] font-medium text-center mb-2">
                  R2R
                </p>
              </div>
              <div
                className="bg-[#02256D]  w-[24%] p-2 flex flex-col justify-center rounded-md cursor-pointer"
                onClick={() => openBusinessModal()}
              >
                <div className="w-[100%] flex justify-end">
                  <FaPlus className="text-[#F1F4F9] text-[12px] cursor-pointer" />
                </div>
                <div className="w-[100%] flex justify-center">
                  <FaThumbsUp className="text-[#F1F4F9] text-[24px]" />
                </div>
                <p className="text-[#F1F4F9] text-[14px] font-medium text-center mb-2">
                  Business
                </p>
              </div>
              <div
                className="bg-[#02256D]  w-[24%] p-2 flex flex-col justify-center rounded-md cursor-pointer"
                onClick={() => openReferenceModal()}
              >
                <div className="w-[100%] flex justify-end">
                  <FaPlus className="text-[#F1F4F9] text-[12px] cursor-pointer" />
                </div>
                <div className="w-[100%] flex justify-center">
                  <LuRefreshCw className="text-[#F1F4F9] text-[24px]" />
                </div>
                <p className="text-[#F1F4F9] text-[14px] font-medium text-center mb-2">
                  Referral
                </p>
              </div>
              <div
                className="bg-[#02256D]  w-[24%] p-2 flex flex-col justify-center rounded-md cursor-pointer"
                onClick={() => openModal("Visitor")}
              >
                <div className="w-[100%] flex justify-end">
                  <FaPlus className="text-[#F1F4F9] text-[12px] cursor-pointer" />
                </div>
                <div className="w-[100%] flex justify-center">
                  <MdVisibility className="text-[#F1F4F9] text-[24px]" />
                </div>
                <p className="text-[#F1F4F9] text-[14px] font-medium text-center mb-2">
                  Visitor
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal
              users={usersData}
              postId={selectedPostId}
              onClose={closeModal}
              currentuser = {userdetails?.id as any}
            />
          </div>
        </div>
      )}

      {isBusinessModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <BusinessModal users={usersData} onClose={closeBusinessModal} />
          </div>
        </div>
      )}

      {isReferenceModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* Close button */}
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <ReferenceModal users={usersData} onClose={closeReferenceModal} />
          </div>
        </div>
      )}
    </div>
  );
};

interface ModalProps {
  postId?: string | null;
  onClose: () => void;
  users: { id: number; name: string }[];
  currentuser : number;
}

const Modal: React.FC<ModalProps> = ({ users, postId, onClose, currentuser}) => {
  const api = process.env.REACT_APP_API_URL as string;
  const[pointdata, setPointdata] = useState<pointstruc[]>([]);
  const [userId, setUserID] = useState();
  const[currentuserId, setCurrentuserId] = useState();
  const[currentuserRole, setCurrentUserRole] =useState();
  useEffect(() => {
    const validateSession = async () => {
      try {
        // Validate the session and retrieve user ID
        const response = await axios.get(`${api}/auth/memberLoggedIn`, {
          withCredentials: true,
        });
        const uid = response.data.user.id;
        setUserID(uid);
        setCurrentuserId(uid);
        setCurrentUserRole(response.data.user.role);
      } catch (error: any) {
        console.error(
          "Session validation failed:",
          error.response?.data || error.message
        );
       
      }
    };

    validateSession();
  }, []);
  useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/point`);
            setPointdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
})
  const [formData, setFormData] = useState({
    discussion_point: "",
    date: "",
    image: null as File | null,
    meetingwith: null as number | null,
    initiatedby: null as number | null,
    location: "",
  });

  useEffect(() => {
    if (userId && currentuserRole!=="super-admin") {
      setFormData((prev) => ({ ...prev, meetingwith: userId }));
    }
  }, [userId]); 
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);

    // handling multiple file
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (
      !formData.meetingwith ||
      !formData.discussion_point ||
      !formData.date ||
      !formData.initiatedby
    ) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
    data.append("discussion_point", formData.discussion_point);
    data.append("date", formData.date);
    data.append("type", postId as string);
    if (formData.image) {
      data.append("image", formData.image);
    } else if (fileName) {
      data.append("image", fileName);
    }
    data.append("meetingwith", String(formData.meetingwith));
    data.append("initiatedby", String(formData.initiatedby));
    data.append("location", formData.location);

    const submitActivityPoint = async (postId: string) => {
      let sentId = 0;
      let totalPoints = 0;
    
      // Determine point type and user
      if (postId === 'R2R') {
        if (formData.initiatedby === currentuser) {
          totalPoints = pointdata
            .filter((item) => item.type === 'R2RHost')
            .reduce((sum, item) => sum + item.data, 0);
          sentId = formData.initiatedby;
        } else if (formData.meetingwith === currentuser) {
          totalPoints = pointdata
            .filter((item) => item.type === 'R2RGuest')
            .reduce((sum, item) => sum + item.data, 0);
          sentId = formData.meetingwith;
        }
      } else if (postId === 'Visitor') {
        if (formData.initiatedby === currentuser) {
          totalPoints = pointdata
            .filter((item) => item.type === 'Visitor')
            .reduce((sum, item) => sum + item.data, 0);
          sentId = formData.initiatedby;
        }
      }
    
      // If no valid user or points, skip the request
      if (sentId === 0 || totalPoints === 0) {
        console.warn("No valid user or points to submit.");
        return;
      }
    
      // Create FormData
      const formDataToSend = new FormData();
      formDataToSend.append("Point", String(totalPoints));
    
      try {
        // Send API request
        await axios.put(`${api}/auth/acitvitypoint/${sentId}`, formDataToSend, {
          headers: { "Content-Type": "application/json" },
        });
        // console.log("Activity points submitted successfully.");
      } catch (err) {
        console.error("Error submitting activity points:", err);
      }
    };
    submitActivityPoint(postId as any);

    try {
      await axios.post(`${api}/auth/memeberpoint/${postId}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      //console.log('memeber point   added  successfully for ', postId);

      onClose();
      window.location.reload();
    } catch (err) {
      console.error("Error submitting post:", err);
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white lg:w-1/2 w-[90%] p-6 rounded shadow relative h-[670px] overflow-y-auto">
        <h1 className="text-darkblue text-2xl text-center font-semibold">
          Add {postId}
        </h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* meeting with */}
          <div>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <select
  name="meetingwith"
  value={formData.meetingwith ?? ""}
  className="w-[100%] border-none outline-none"
  onChange={(e) =>
    setFormData({
      ...formData,
      meetingwith:
        e.target.value === "" ? null : Number(e.target.value),
    })
  }
  disabled={currentuserRole !== "super-admin"}
>
  {/* Show default option only for super-admins */}
  {currentuserRole === "super-admin" && (
    <option value="" disabled>
      Select Guest
    </option>
  )}

  {(currentuserRole === "super-admin"
    ? users
    : users.filter((user) => user.id === currentuserId)
  ).map((user) => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
</select>



              <select
                name="meetingwith"
                id=""
                value={formData.meetingwith ?? ""} // Use '' if no value is selected
                className="w-[100%] border-none outline-none hidden"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    meetingwith:
                      e.target.value === "" ? null : Number(e.target.value), // Parse value as number or set to null
                  })
                }
                disabled
              >
                <option value="" disabled>
                  Guest
                </option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* initiatedby */}
          <div>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
              <select
                name="RMBiansOfMeeting"
                id=""
                value={formData.initiatedby ?? ""} // Use '' if no value is selected
                className="w-[100%] border-none outline-none"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    initiatedby:
                      e.target.value === "" ? null : Number(e.target.value), // Parse value as number or set to null
                  })
                }
                
              >
                <option value="" disabled>
                  Host By
                </option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* location */}
          <div>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              className="mt-1 mb-4 p-2 block w-full h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
              placeholder="Location "
              required
            />
          </div>
          {/* Date */}
          <div className="flex flex-col  w-full ">
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="mt-1 h-[50px] bg-transparent placeholder-[#94A2B8] outline-none  border  border-[#94A2B8] rounded-md p-1 text-[14px]"
              required
            />
          </div>
          {/* Discussion Point */}
          <div>
            <input
              type="text"
              name="discussion_point"
              value={formData.discussion_point}
              onChange={handleChange}
              className="mt-1 mb-4 p-2 block w-full h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
              placeholder="Discussion Point"
              required
            />
          </div>

          {/* File Upload */}
          <div>
            <label className="text-[#030303]  font-medium"> </label>
            <div className="mt-1 w-[100%] h-[150px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">
              <RiGalleryUploadLine
                size={24}
                className="text-[30px] cursor-pointer"
                onClick={() => document.getElementById("file-upload")?.click()}
              />
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name="image"
                onChange={handleFileChange}
              />
              {fileName ? (
                <p className="text-[14px] text-[#02256d] mt-2">
                  Selected file: <span className="font-bold">{fileName}</span>
                </p>
              ) : (
                <p className="font-bold text-[14px]">
                  Drop image <span className="text-[#02256d]">here..</span>
                </p>
              )}
            </div>
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.meetingwith ||
                  !formData.discussion_point ||
                  !formData.date
                }
              >
                {`Submit ${postId}`}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

interface BusinessModalProps {
  onClose: () => void;
  users: { id: number; name: string }[];
}
const BusinessModal: React.FC<BusinessModalProps> = ({ users, onClose }) => {
  const api = process.env.REACT_APP_API_URL as string;
  const [userId, setUserID] = useState();
  const[currentUserID, setCurrentUserID] = useState();
  const[currentUserRole, setCurrentUserRole] = useState();
  useEffect(() => {
    const validateSession = async () => {
      try {
        // Validate the session and retrieve user ID
        const response = await axios.get(`${api}/auth/memberLoggedIn`, {
          withCredentials: true,
        });
        const uid = response.data.user.id;
        setUserID(uid);
        setCurrentUserID(uid);
        setCurrentUserRole(response.data.user.role);
      } catch (error: any) {
        console.error(
          "Session validation failed:",
          error.response?.data || error.message
        );
       
      }
    };

    validateSession();
  }, []);
  const [formData, setFormData] = useState({
    date: "",
    giver: null as number | null,
    receiver: null as number | null,
    workBy: "",
    amount: null as number | null ,
  });

  useEffect(() => {
    if (userId && currentUserRole!=="super-admin") {
      setFormData((prev) => ({ ...prev, giver: userId }));
    }
  }, [userId]); 
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (
      !formData.date ||
      !formData.receiver ||
      !formData.date ||
      !formData.workBy
    ) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
    data.append("giver", String(formData.giver));
    data.append("date", formData.date);
    data.append("receiver", String(formData.receiver));
    data.append("workBy", formData.workBy);
    data.append("amount", String(formData.amount));

    // console.log(
    //   "data from business",
    //   formData.date,
    //   formData.giver,
    //   formData.receiver,
    //   formData.workBy
    // );
    // alert('checking data');
    try {
      await axios.post(`${api}/auth/business/`, data, {
        headers: { "Content-Type": "application/json" },
      });

      onClose();
      window.location.reload();
    } catch (err) {
      console.error("Error submitting post:", err);
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white lg:w-1/2 w-[90%] p-6 rounded shadow relative h-auto overflow-y-auto">
        {/* <h1 className='text-darkblue text-2xl text-center font-semibold'>Add {postId}</h1> */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* meeting with */}
          <div>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <select
  name="giver"
  value={formData.giver ?? ""}
  className="w-[100%] border-none outline-none"
  onChange={(e) =>
    setFormData({
      ...formData,
      giver: e.target.value === "" ? null : Number(e.target.value),
    })
  }
  disabled={currentUserRole !== "super-admin"} // Disable only if not admin
>
  <option value="" disabled>
    Business Giver
  </option>

  {(currentUserRole === "super-admin" ? users : users.filter(user => user.id === currentUserID)).map(
    (user) => (
      <option key={user.id} value={user.id}>
        {user.name}
      </option>
    )
  )}
</select>

              <select
                name="giver"
                id=""
                value={formData.giver ?? ""} // Use '' if no value is selected
                className="w-[100%] hidden border-none outline-none"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    giver:
                      e.target.value === "" ? null : Number(e.target.value), // Parse value as number or set to null
                  })
                }
                disabled
              >
                <option value="" disabled>
                  Business Giver
                </option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Receiver */}
          <div>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
              <select
                name="RMBiansOfMeeting"
                id=""
                value={formData.receiver ?? ""} // Use '' if no value is selected
                className="w-[100%] border-none outline-none"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    receiver:
                      e.target.value === "" ? null : Number(e.target.value), // Parse value as number or set to null
                  })
                }
              >
                <option value="" disabled>
                  Business Receiver
                </option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* work by Point */}

          <div>
            <select
              className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
              value={formData.workBy} // Bind to state
              onChange={
                (e) => setFormData({ ...formData, workBy: e.target.value }) // Update the role in state
              }
            >
              <option value="Self">Self</option>
              <option value="Reference">Reference</option>
            </select>
          </div>
          {/* amount */}

          <div>
  <input
    type="number"
    className="mt-1 mb-4 p-2 block w-full h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
    value={formData.amount || ''} // Fallback to empty string if undefined/null
    onChange={(e) =>
      setFormData({ ...formData, amount: parseFloat(e.target.value) || 0 })
    }
    placeholder="Enter amount"
  />
</div>

          {/* Date */}
          <div className="flex flex-col  w-full ">
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="mt-1 h-[50px] bg-transparent placeholder-[#94A2B8] outline-none  border  border-[#94A2B8] rounded-md p-1 text-[14px]"
              required
            />
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.giver || !formData.receiver || !formData.workBy
                }
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

interface ReferenceModalProps {
  onClose: () => void;
  users: { id: number; name: string }[];
}

const ReferenceModal: React.FC<ReferenceModalProps> = ({ users, onClose }) => {
  const api = process.env.REACT_APP_API_URL as string;
  const [userId, setUserID] = useState();
  const[currentuserID, setCurrentUserID] = useState();
  const[currentuserRole, setCurrentUserRole] = useState();
  useEffect(() => {
    const validateSession = async () => {
      try {
        // Validate the session and retrieve user ID
        const response = await axios.get(`${api}/auth/memberLoggedIn`, {
          withCredentials: true,
        });
        const uid = response.data.user.id;
        setUserID(uid);
        setCurrentUserID(uid);
        setCurrentUserRole(response.data.user.role);
      } catch (error: any) {
        console.error(
          "Session validation failed:",
          error.response?.data || error.message
        );
       
      }
    };

    validateSession();
  }, []);
  const [formData, setFormData] = useState({
    referenceBy: null as number | null,
    referenceTo: null as number | null,
    number: null as number | null,
    RefPerName: "",
    date: "",
  });

  useEffect(() => {
    if (userId && currentuserRole!=="super-admin") {
      setFormData((prev) => ({ ...prev, referenceBy: userId }));
    }
  }, [userId]); 

  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>("");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);

    // handling multiple file
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (
      !formData.RefPerName ||
      !formData.referenceBy ||
      !formData.referenceTo ||
      !formData.number ||
      !formData.date
    ) {
      setError("All fields are required.");
      return;
    }

    const data = new FormData();
    data.append("RefPerName", formData.RefPerName);
    data.append("date", formData.date);

    data.append("referenceTo", String(formData.referenceTo));
    data.append("referenceBy", String(formData.referenceBy));
    data.append("number", String(formData.number));

    try {
      await axios.post(`${api}/auth/reference/`, data, {
        headers: { "Content-Type": "application/json" },
      });
      //console.log('memeber point   added  successfully for ', postId);

      onClose();
      window.location.reload();
    } catch (err) {
      console.error("Error submitting post:", err);
      setError("Failed to submit the post. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white lg:w-1/2 w-[90%] p-6 rounded shadow relative h-auto overflow-y-auto">
        {/* <h1 className='text-darkblue text-2xl text-center font-semibold'>Add {postId}</h1> */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* meeting with */}
          <div>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <select
  name="referenceBy"
  value={formData.referenceBy ?? ""}
  className="w-[100%] border-none outline-none"
  onChange={(e) =>
    setFormData({
      ...formData,
      referenceBy:
        e.target.value === "" ? null : Number(e.target.value),
    })
  }
  disabled={currentuserRole !== "super-admin"} // Optional: disable for non-admins
>
  <option value="" disabled>
    Reference By
  </option>
  {(currentuserRole === "super-admin"
    ? users
    : users.filter((user) => user.id === currentuserID)
  ).map((user) => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
</select>

              <select
                name="referenceBy"
                id=""
                value={formData.referenceBy ?? ""} // Use '' if no value is selected
                className="w-[100%] border-none outline-none hidden"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    referenceBy:
                      e.target.value === "" ? null : Number(e.target.value), // Parse value as number or set to null
                  })
                }
                disabled
              >
                <option value="" disabled>
                  Reference By
                </option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Receiver */}
          <div>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
              
              <select
                name="referenceTo"
                id=""
                value={formData.referenceTo ?? ""} // Use '' if no value is selected
                className="w-[100%] border-none outline-none"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    referenceTo:
                      e.target.value === "" ? null : Number(e.target.value), // Parse value as number or set to null
                  })
                }
              >
                <option value="" disabled>
                  Reference To
                </option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* work by Point */}

          <div>
            <input
              type="text"
              className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
              name="RefPerName"
              value={formData.RefPerName} // Bind to state
              onChange={
                (e) => setFormData({ ...formData, RefPerName: e.target.value }) // Update the role in state
              }
              placeholder="Enter Refer Person Name"
            ></input>
          </div>

          <div>
            <input
              type="number"
              name="number"
              className="mt-1 mb-4 p-2 block w-full  h-[50px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
              value={formData.number ?? ""} // Bind to state
              onChange={
                (e) =>
                  setFormData({ ...formData, number: Number(e.target.value) }) // Update the role in state
              }
              placeholder="Enter Refer Person Name"
            ></input>
          </div>

          {/* Date */}
          <div className="flex flex-col  w-full ">
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              className="mt-1 h-[50px] bg-transparent placeholder-[#94A2B8] outline-none  border  border-[#94A2B8] rounded-md p-1 text-[14px]"
              required
            />
          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}

          <div className=" flex justify-between">
            <div className="flex items-center">
              {/*Cancel form button*/}
              <button
                className="mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold"
                onClick={onClose}
              >
                Cancel
              </button>
              {/* Submit Button */}
              <button
                type="submit"
                className="mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold"
                disabled={
                  !formData.number ||
                  !formData.referenceBy ||
                  !formData.RefPerName ||
                  !formData.referenceTo
                }
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};



export default Userdashbord;
